import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

class RecommendSlides {
  constructor(el) {
    this.dom = {el: el};

    const easeOutCubic = (x) => {
      return 1 - Math. pow(1 - x, 3);
    }

    this.slider = null;
    this.option = {
      loop: true,
      slides: {
        // origin: 'center',
        perView: 345 / 240,
      },
      defaultAnimation: {
        duration: 1600,
        easing: easeOutCubic,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            // origin: 'auto',
            perView: 1296 / 588,
          },
        },
      },
      // created: () => {
      //   console.log('created')
      // }
    }

    this.plugins = [
      (slider) => {
        let timeout
        let mouseOver = false
        function clearNextTimeout() {
          clearTimeout(timeout)
        }
        function nextTimeout() {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            slider.next()
          }, 4000)
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on("dragStarted", clearNextTimeout)
        slider.on("animationEnded", nextTimeout)
        slider.on("updated", nextTimeout)
      },
    ]

    this.init();
  }

  init() {
    this.slider = new KeenSlider(this.dom.el, this.option, this.plugins);
  }
}

export default RecommendSlides